import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { theme } from "../../theme";
import Avatar from "@mui/material/Avatar";
import ListItemText from "./list-item-text";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStethoscope } from "@fortawesome/free-solid-svg-icons";

const PanelMedicoPreview = (props) => {
  const { medico, estilos, onClick, fields } = props;
  const classes = useStyles(theme);

  const existsField = (array, fieldName) => 
    Array.isArray(array) && array.length > 0 && array.some((field) => field.nombre === fieldName);

  return (
    <div className={classes.card}>
      <div
        className={classes.header}
        style={{ backgroundColor: estilos.backgroundColorAccent }}
      >
        <div className={classes.sectionName}>
          <Avatar variant="rounded" sx={{ height: 64, width: 64 }}>
            <FontAwesomeIcon icon={faStethoscope} size="xl" />
          </Avatar>
          <div className={classes.sectionText}>
            <Typography
              sx={{
                fontSize: "13.5px",
                lineHeight: "25px",
                color: estilos.colorTextPrimary,
              }}
            >
              Médico
            </Typography>
            {medico.nombreMedico && medico.apellidoMedico && (
              <Typography
                sx={{
                  fontSize: "17.6px",
                  lineHeight: "25px",
                  color: estilos.colorTextSecondary,
                }}
              >
                {medico.nombreMedico} {medico.apellidoMedico}
              </Typography>
            )}
          </div>
        </div>
      </div>
      <div className={classes.body}>
        <ListItemText
          color={estilos.colorTextSecondary}
          label={"Tipo de Matrícula"}
          data={medico.tipoMatricula}
        />
        <ListItemText
          color={estilos.colorTextSecondary}
          label={"Nro. de Matrícula"}
          data={medico.nroMatricula}
        />
        {existsField(fields, "Especialidad") && (
          <ListItemText
            color={estilos.colorTextSecondary}
            label={"Especialidad"}
            data={medico.especialidad}
          />
        )}
        {existsField(fields, "Telefono") && (
          <ListItemText
            color={estilos.colorTextSecondary}
            label={"Teléfono"}
            data={medico.telefono}
          />
        )}
        {existsField(fields, "FechaNac") && (
          <ListItemText
            color={estilos.colorTextSecondary}
            label={"Fecha de Nacimiento"}
            data={medico.fechaNacimiento}
          />
        )}
        {existsField(fields, "Sexo") && (
          <ListItemText
            color={estilos.colorTextSecondary}
            label={"Sexo"}
            data={medico.sexo}
          />
        )}
        {existsField(fields, "Email") && (
          <ListItemText
            color={estilos.colorTextSecondary}
            label={"Email"}
            data={medico.email}
          />
        )}
        {existsField(fields, "DireccionConsultorio") && (
          <ListItemText
            color={estilos.colorTextSecondary}
            label={"Dirección del consultorio"}
            data={medico.direccionConsultorio}
          />
        )}
        {existsField(fields, "TipoDoc") &&
              existsField(fields, "NroDoc") && (
                <ListItemText
                  color={estilos.colorTextSecondary}
                  label={medico.tipoDocumento}
                  data={medico.nroDocumento}
                />
              )}
      </div>
    </div>
  );
};

export default PanelMedicoPreview;

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: "white",
    borderRadius: 7,
    boxShadow: "0px 2px 1px -1px rgba(0, 0, 0, 0.2)",
    margin: "5px",
    border: "1px solid rgba(0, 0, 0, 0.14)",
    filter:
      "dropShadow(0px 1px 1px rgba(0, 0, 0, 0.14)) dropShadow(0px 1px 3px rgba(0, 0, 0, 0.12))",
  },
  header: {
    backgroundColor: "#E3E3E3",
    height: 100,
    padding: 15,
  },
  sectionSetting: {
    alignSelf: "flex-start",
    padding: 15,
  },
  sectionName: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: 0,
    gap: "16",
  },
  sectionText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: 0,
    paddingLeft: "16px",
  },
  body: {
    display: "flex",
    padding: 15,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 16,
  },
}));
